module.exports = __webpack_public_path__ + "static/media/Logo__Ripplematch.405375d7.svg";